export type PickerPanelCoords = {
  top: number;
  left: number;
  width: number;
};

export type ComputePickerPanelCoordsArgs = {
  triggerRect: Pick<DOMRect, 'top' | 'bottom' | 'left' | 'width'>;
  viewportWidth: number;
  viewportHeight: number;
  estimatedHeight: number;
  measuredHeight?: number | null;
  minWidth: number;
  maxWidth: number;
  margin?: number;
};

/** Keep date/time picker popovers fully inside the viewport on any device size. */
export function computePickerPanelCoords({
  triggerRect,
  viewportWidth,
  viewportHeight,
  estimatedHeight,
  measuredHeight,
  minWidth,
  maxWidth,
  margin = 8,
}: ComputePickerPanelCoordsArgs): PickerPanelCoords {
  const availableWidth = Math.max(0, viewportWidth - margin * 2);
  const preferredWidth = Math.max(minWidth, triggerRect.width);
  const width = Math.min(maxWidth, preferredWidth, availableWidth);

  const panelHeight =
    measuredHeight && measuredHeight > 0 ? measuredHeight : estimatedHeight;

  const spaceBelow = viewportHeight - triggerRect.bottom - margin;
  const spaceAbove = triggerRect.top - margin;
  const openUp = spaceBelow < panelHeight && spaceAbove > spaceBelow;

  let top = openUp ? triggerRect.top - panelHeight - 4 : triggerRect.bottom + 4;
  const maxTop = Math.max(margin, viewportHeight - panelHeight - margin);
  top = Math.min(Math.max(margin, top), maxTop);

  const maxLeft = Math.max(margin, viewportWidth - width - margin);
  const left = Math.min(Math.max(margin, triggerRect.left), maxLeft);

  return { top, left, width };
}
